// src/context/GlobalContext.js
import React, { createContext, useState } from 'react';

// Create the context
export const visitedContext = createContext();

// Create a provider component
export const VisitedProvider = ({ children }) => {
  const [visitedPage, setVisitedPage] = useState({contact:false,home:false,projects:false,about:false}); // Initialize the global variable

  return (
    <visitedContext.Provider value={{visitedPage, setVisitedPage }}>
      {children}
    </visitedContext.Provider>
  );
};

